// Idle-Logout für das Admin-Panel.
// Strikter als Praxis (Admin hat Zugriff auf alle Praxen + Stats):
// 15 Min Idle-Timeout, 1 Min Warnung.

import { useEffect, useRef } from 'react';

const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const WARNING_MS = 60 * 1000;

interface UseIdleLogoutOpts {
  enabled: boolean;
  onIdle: () => void;
  onWarning?: () => void;
}

export function useIdleLogout({ enabled, onIdle, onWarning }: UseIdleLogoutOpts) {
  const timer = useRef<number | null>(null);
  const warning = useRef<number | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const reset = () => {
      if (timer.current !== null) window.clearTimeout(timer.current);
      if (warning.current !== null) window.clearTimeout(warning.current);
      warning.current = window.setTimeout(() => onWarning?.(), IDLE_TIMEOUT_MS - WARNING_MS);
      timer.current = window.setTimeout(() => onIdle(), IDLE_TIMEOUT_MS);
    };

    const events = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll', 'click'] as const;
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    reset();

    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      if (timer.current !== null) window.clearTimeout(timer.current);
      if (warning.current !== null) window.clearTimeout(warning.current);
    };
  }, [enabled, onIdle, onWarning]);
}
